export const constants = {
  http: {
    defaultApi: '/',
  },
  shopUrl: {
    shopRouteLink: '/au/shop',
    storesRouteLink: '/stores',
    shopCategoryRouteLink: '/au/shop',
  },
};

export const urlsByEnvironment = (env: string) => {
  let baseUrlZip = null;
  let baseUrlMerchant = null;
  let baseUrlPayAccount = null;
  let baseUrlMoneyAccount = null;
  let baseUrlBusinessAccount;
  switch (env) {
    case 'local':
      baseUrlZip = 'https://dev.zip.co';
      baseUrlMerchant = 'https://merchant-login.dev.zip.co/login';
      baseUrlPayAccount = 'https://start.dev.zip.co';
      baseUrlMoneyAccount = 'https://my.dev1.zipmoney.com.au';
      baseUrlBusinessAccount = 'https://business.dev.zip.co';
      break;
    case 'development':
      baseUrlZip = 'https://dev.zip.co';
      baseUrlMerchant = 'https://merchant-login.dev.zip.co/login';
      baseUrlPayAccount = 'https://start.dev.zip.co';
      baseUrlMoneyAccount = 'https://my.dev1.zipmoney.com.au';
      baseUrlBusinessAccount = 'https://business.dev.zip.co';
      break;
    case 'staging':
      baseUrlZip = 'https://sandbox.zip.co';
      baseUrlMerchant = 'https://merchant-login.sandbox.zip.co/login';
      baseUrlPayAccount = 'https://start.sandbox.zip.co';
      baseUrlMoneyAccount = 'https://my.sandbox.zipmoney.com.au';
      baseUrlBusinessAccount = 'https://business.sandbox.zip.co';
      break;
    case 'production':
      baseUrlZip = 'https://zip.co';
      baseUrlMerchant = 'https://merchant-login.zip.co/login';
      baseUrlPayAccount = 'https://start.zip.co';
      baseUrlMoneyAccount = 'https://my.zipmoney.com.au';
      baseUrlBusinessAccount = 'https://business.zip.co';
      break;
    default:
      baseUrlZip = 'https://zip.co';
      baseUrlMerchant = 'https://merchant-login.zip.co/login';
      baseUrlPayAccount = 'https://start.zip.co';
      baseUrlMoneyAccount = 'https://my.zipmoney.com.au';
      baseUrlBusinessAccount = 'https://business.zip.co';
  }

  const urls = {
    auth: {
      customerLogin: `${baseUrlZip}/customer/account-selector/`,
      merchantLogin: `${baseUrlMerchant}`,
      zipPaySignup: `${baseUrlPayAccount}/?`,
      zipMoneySignup: `${baseUrlMoneyAccount}/?sso=sign-up`,
      zipBusinessSignup: `${baseUrlBusinessAccount}/signup/?source=partner&pdata=259cd2940e774144124cde26a1ed3fb99957b39ddfb6db3457bc602b`,
      zipBusinessLogin: `${baseUrlBusinessAccount}/login`,
    },
  };

  return urls;
};

export enum contentTypeIds {
  image = 'image',
  button = 'button',
  actionLink = 'actionLink',
  indexedList = 'indexedList',
  favouriteStore = 'favouriteStore',
  partnerList = 'partnerList',
  merchantOutList = 'merchantOutList',
  category = 'category',
  carousel = 'carousel',
  mainHero = 'mainHero',
  sidekickHero = 'sidekickHero',
  blogPost = 'blogPost',
  calloutBanner = 'calloutBanner',
  threeTileBlock = 'threeTileBlock',
  categoryBanners = 'categoryBanners',
  favouriteStores = 'favouriteStores',
  smallBanner = 'smallBanner',
  largeBanner = 'largeBanner',
  fourTileBannerBlock = 'fourTileBannerBlock',
  fourTileBlock = 'fourTileBlock',
  twoTileBlock = 'twoTileBlock',
  shopPage = 'shopPage',
  shopSubPages = 'shopSubPages',
  page = 'page',
  productTile = 'storeTileNoOpacity',
  doubleFourTileBlock = 'doubleFourTileBlockNoOpacityTest',
  categoryTags = 'categoryTags',
  categoryTagBlock = 'categoryTagBlock',
  dealTileBlock = 'sectionDealsTileBlock',
  textImageDoubleTile = 'textImageDoubleTile',
  productLandingPages = 'productLandingPages',
  footerComponent = 'footerComponent',
  referralTermCondition = 'referralTermCondition',
  youtubeIDs = 'youtubeIDs',
  testimonials = 'testimonials',
  featureCarouselsSection = 'featureCarouselsSection',
  section = 'section',
  collage = 'collage',
  chromeExtensionScreen = 'chromeExtensionScreen',
}

export const siteCountries: {
  [key in 'AU' | 'CA' | 'NZ' | 'US']: {
    name: string;
    icon: string;
    users: string;
    path: string;
    timezones: string[];
  };
} = {
  AU: {
    name: 'Australia',
    icon: 'https://static.zip.co/assets/flags/flag-au.svg',
    path: '/',
    users: '2 million',
    timezones: [
      'Australia/Lord_Howe',
      'Antarctica/Macquarie',
      'Australia/Hobart',
      'Australia/Currie',
      'Australia/Melbourne',
      'Australia/Sydney',
      'Australia/Broken_Hill',
      'Australia/Brisbane',
      'Australia/Lindeman',
      'Australia/Adelaide',
      'Australia/Darwin',
      'Australia/Perth',
      'Australia/Eucla',
      'Pacific/Norfolk',
    ],
  },
  CA: {
    name: 'Canada',
    icon: 'https://static.zip.co/assets/flags/flag-canada.svg',
    path: '/en-ca',
    users: '',
    timezones: ['Pacific/Vancouver'],
  },
  NZ: {
    name: 'New Zealand',
    icon: 'https://static.zip.co/assets/flags/flag-nz.svg',
    path: '/nz',
    users: '',
    timezones: ['Pacific/Auckland'],
  },
  US: {
    name: 'United States',
    icon: 'https://static.zip.co/assets/flags/flag-us.svg',
    path: '/us',
    users: '2m',
    timezones: ['America/New_York'],
  },
};

export const isRenderingForMobileApp =
  (window['isNativeApp'] && window['isNativeApp'] === 'true') ||
  /zip\s?.*?\/[\d|\.]+/gim.test(navigator.userAgent);

export const AMAZON_CARD_ID = 'AUBHNAMZC001';
export const CHECKOUT_REQUEST_SESSION_KEY = 'loyalty-gift-cards-checkout-request';
export const IS_CHECKOUT_CREATED_SESSION_KEY = 'loyalty-gift-cards-is-checkout-created';
export const CURRENT_ENTRY_ID_SESSION_KEY = 'loyalty-gift-cards-card-current-entry-id';
